// 
// -----------------------------------------------------------------------------
(function ($element) {
	if ($element.length === 0) {return false;}

})($( '#element' ));